const s = (i) => i ?? "", l = (i) => i ? {
  url: i.image.url,
  viewport: i.viewport,
  altText: i.alt_text
} : N, N = { url: "", altText: "", viewport: [] }, U = (i) => {
  var o, e, n, d, u, r, a, t, v, g, p, m, c, _, w, f, C, k, T, D, b, x, P, S, A, L, M, R;
  const B = {
    landingImage: l((e = (o = i == null ? void 0 : i.coapp) == null ? void 0 : o.coapp_landing_image) == null ? void 0 : e.images[0]),
    pendingImage: l((d = (n = i == null ? void 0 : i.coapp) == null ? void 0 : n.coapp_pending_image) == null ? void 0 : d.images[0]),
    completedImage: l((r = (u = i == null ? void 0 : i.coapp) == null ? void 0 : u.coapp_completed_image) == null ? void 0 : r.images[0]),
    registrationImage: l((t = (a = i == null ? void 0 : i.coapp) == null ? void 0 : a.coapp_registration_image) == null ? void 0 : t.images[0]),
    marriageCertImage: l((g = (v = i == null ? void 0 : i.coapp) == null ? void 0 : v.coapp_marriage_cert) == null ? void 0 : g.images[0]),
    tnc: (p = i == null ? void 0 : i.coapp) == null ? void 0 : p.coapp_tnc,
    coappRegistrationImage: (c = (m = i == null ? void 0 : i.coapp) == null ? void 0 : m.coapp_registration_image) == null ? void 0 : c.images
  };
  return {
    title: i == null ? void 0 : i.title,
    locale: i == null ? void 0 : i.locale,
    signUpCustomer: {
      customerImage: l((_ = i == null ? void 0 : i.sign_up_customer) == null ? void 0 : _.images[0]),
      ABOImage: l((w = i == null ? void 0 : i.sign_up_abo) == null ? void 0 : w.images[0])
    },
    profileComplete: {
      image: l((f = i == null ? void 0 : i.profile_completed) == null ? void 0 : f.images[0]),
      title: (i == null ? void 0 : i.profile_completed_title) ?? "",
      subTitle: (i == null ? void 0 : i.profile_completed_sub_title) ?? "",
      desc: (i == null ? void 0 : i.profile_completed_description) ?? ""
    },
    selectSponsor: {
      internationalSponsorTnc1: (i == null ? void 0 : i.international_sponsor_tnc1) ?? "",
      internationalSponsorTnc2: (i == null ? void 0 : i.international_sponsor_tnc2) ?? ""
    },
    passportLoading: l((C = i == null ? void 0 : i.passport_loading) == null ? void 0 : C.images[0]),
    personalDetailsDesktopImage: l((k = i == null ? void 0 : i.personal_details_desktop_image) == null ? void 0 : k.images[0]),
    sampleCid: l((T = i == null ? void 0 : i.sample_cid) == null ? void 0 : T.images[0]),
    sampleCidBack: l((b = (D = i == null ? void 0 : i.sample_cid) == null ? void 0 : D.images) == null ? void 0 : b[1]),
    samplePassport: l((x = i == null ? void 0 : i.sample_passport) == null ? void 0 : x.images[0]),
    cidLoading: l((P = i == null ? void 0 : i.cid_loading) == null ? void 0 : P.images[0]),
    noRecordImage: l((S = i == null ? void 0 : i.no_record) == null ? void 0 : S.images[0]),
    googleIcon: l((A = i == null ? void 0 : i.google_icon) == null ? void 0 : A.images[0]),
    facebookIcon: l((L = i == null ? void 0 : i.facebook_icon) == null ? void 0 : L.images[0]),
    coApp: B,
    // Account Lifecycle
    accountCardImage: l((M = i == null ? void 0 : i.account_card_image) == null ? void 0 : M.images[0]),
    accountUpgradeImage: l((R = i == null ? void 0 : i.account_upgrade_image) == null ? void 0 : R.images[0])
  };
}, h = (i) => {
  var o, e, n;
  return {
    locale: i == null ? void 0 : i.locale,
    termsAndConditions: (o = i == null ? void 0 : i.terms_and_conditions) == null ? void 0 : o.description,
    landingPageDetails: (e = i == null ? void 0 : i.landing_page_details) == null ? void 0 : e.details,
    findoutMorePageDetails: (n = i == null ? void 0 : i.find_out_more_page_details) == null ? void 0 : n.description
  };
}, E = (i) => i.map((o) => l(o)), O = (i) => {
  var o, e, n, d, u, r, a;
  return {
    locale: i == null ? void 0 : i.locale,
    landingPageImage: (e = (o = i == null ? void 0 : i.landing_page_image) == null ? void 0 : o.images) == null ? void 0 : e.map((t) => l(t)),
    idVerificationImage: (d = (n = i == null ? void 0 : i.id_verification_image_desktop) == null ? void 0 : n.images) == null ? void 0 : d.map((t) => l(t)),
    findoutMoreImage: (r = (u = i == null ? void 0 : i.findout_more_image) == null ? void 0 : u.images) == null ? void 0 : r.map((t) => l(t)),
    personalDetailsImage: l((a = i == null ? void 0 : i.personal_details_desktop_image) == null ? void 0 : a.images[0])
  };
}, V = (i) => {
  var o, e, n, d, u, r, a, t, v, g, p, m, c, _;
  return {
    title: (i == null ? void 0 : i.title) ?? "",
    locale: i == null ? void 0 : i.locale,
    renewalCardImage: l((o = i == null ? void 0 : i.renewal_card_image) == null ? void 0 : o.images[0]),
    upgradeScreenImage: l((e = i == null ? void 0 : i.upgrade_screen_image) == null ? void 0 : e.images[0]),
    upgradeDesktopImage: l((n = i == null ? void 0 : i.upgrade_screen_desktop_image) == null ? void 0 : n.images[0]),
    renewalTermsCondition: {
      title: s((d = i == null ? void 0 : i.renewal_terms_conditions) == null ? void 0 : d.title),
      description: s((u = i == null ? void 0 : i.renewal_terms_conditions) == null ? void 0 : u.description)
    },
    upgradeTermsCondition: {
      title: s((r = i == null ? void 0 : i.upgrade_terms_and_conditions) == null ? void 0 : r.title),
      description: s((a = i == null ? void 0 : i.upgrade_terms_and_conditions) == null ? void 0 : a.description)
    },
    downgradeTermsCondition: {
      title: s((t = i == null ? void 0 : i.downgrade_terms_and_conditions) == null ? void 0 : t.title),
      description: s((v = i == null ? void 0 : i.downgrade_terms_and_conditions) == null ? void 0 : v.description)
    },
    downgradeModalPrivileges: s((g = i == null ? void 0 : i.downgrade_modal_privileges) == null ? void 0 : g.description),
    autoRenewalTermsCondition: {
      title: s((p = i == null ? void 0 : i.auto_renewal_terms_and_conditions) == null ? void 0 : p.title),
      description: s((m = i == null ? void 0 : i.auto_renewal_terms_and_conditions) == null ? void 0 : m.description)
    },
    eKitTermsCondition: {
      title: s((c = i == null ? void 0 : i.ekit_terms_and_conditions) == null ? void 0 : c.title),
      description: s((_ = i == null ? void 0 : i.ekit_terms_and_conditions) == null ? void 0 : _.description)
    }
  };
}, I = {
  iconName: "",
  url: "",
  status: !0
}, j = {
  registration: I,
  personaldetails: I,
  esignature: I,
  order: I
}, q = (i) => {
  var o;
  const e = {
    title: (i == null ? void 0 : i.title) ?? "",
    icons: j
  };
  return (o = i == null ? void 0 : i.icon_details) == null || o.forEach((n) => {
    const d = n.task_name.toLowerCase();
    if (d in e.icons) {
      const u = d;
      e.icons[u] = {
        iconName: n.icon.text,
        url: n.icon.url,
        status: n.status
      };
    }
  }), e;
}, y = (i) => ({ data: U(i) }), z = (i) => ({ data: E(i) }), F = (i) => ({ data: h(i) }), G = (i) => ({ data: q(i) }), H = (i) => ({ data: O(i) }), K = (i) => ({ data: V(i) });
export {
  K as $,
  y as Q,
  N as U,
  z as W,
  F as X,
  G as Y,
  H as Z
};
//# sourceMappingURL=cmsTransformer-239cfecd.mjs.map
